module.exports = __webpack_public_path__ + "static/media/save-svgrepo-com (1).0887b53a.svg";